import React from "react"
import { Box } from "@mui/material"
import {
	Create,
	NumberInput,
	required,
	SimpleForm,
	TextInput,
	useNotify,
	useRedirect,
	useRefresh
} from "react-admin"

import sx from "utils/sx"

const PatronagePackCreate = () => {
	const notify = useNotify()
	const refresh = useRefresh()
	const redirect = useRedirect()

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const onSuccess = (data: any) => {
		notify(
			"resources.patronage_packs.notifications.create",
			{
				type: "info",
				messageArgs: { name: data.name }
			}
		)
		redirect("/patronage-packs")
		refresh()
	}

	return (
		<Create
			mutationOptions={{ onSuccess }}
			title="resources.patronage_packs.create"
		>
			<SimpleForm>
				<Box sx={sx.prose}>
					<TextInput
						label="resources.patronage_packs.fields.name"
						source="name"
						validate={required()}
						fullWidth
					/>
					<NumberInput
						label="resources.patronage_packs.fields.price"
						source="price"
						validate={required()}
						fullWidth
					/>
					<NumberInput
						label="resources.patronage_packs.fields.ticket_numbers"
						source="ticketNumbers"
						validate={required()}
						fullWidth
					/>
				</Box>
			</SimpleForm>
		</Create>
	)
}

export default PatronagePackCreate
